import { Capacitor } from '@capacitor/core';

// Evaluated once at module load — Capacitor bridge is synchronously ready before JS runs.
// Using a constant (not a function) ensures consistent value across all renders.
export const IS_NATIVE = Capacitor.isNativePlatform();
export const PLATFORM = Capacitor.getPlatform(); // 'android' | 'ios' | 'web'

// Legacy function aliases — kept for back-compat
export const isNativeApp = () => IS_NATIVE;
export const getPlatform = () => PLATFORM;
